import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { LocationPickerComponent } from '../../../../../common/components/location-picker/location-picker.component';

import Policy from '../../../../../core/data/models/policy.mode';
import ClaimTypes from '../../../../../common/enums/claimTypes';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  Injured,
  VehicleFormComponent,
} from './vehicle-form/vehicle-form.component';
import { CristalFormComponent } from './cristal-form/cristal-form.component';
import {
  NgbDatepickerModule,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbTimepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../../../../../common/utils/custom-date-parser-formatter';
import repDomCoords from '../../../../../common/constants/repDomCoords';
import { lastValueFrom, Subscription } from 'rxjs';
import { ImageType } from '../../../../../core/data/models/ImageType';
import { ClaimService } from '../../../services/claim.service';
import VehicleClaimRequest from '../../../../../core/data/dtos/vehicleClaimRequest';
import {
  ValidationModalComponent,
  ValidationModalResponse,
} from '../validation-modal/validation-modal.component';
import { AuthService } from '../../../../auth/services/auth.service';
import User from '../../../../../core/data/models/user.model';
import { SwalService } from '../../../../../common/services/swal.service';
import ClaimGlassRequest from '../../../../../core/data/dtos/claim.glass.request';
import { SharedModule } from '../../../../../common/shared.module';
import { FilePondModule } from 'ngx-filepond';
import pictureTypes from '../../../../../common/enums/pictureTypes';
import PictureTypes from '../../../../../common/enums/pictureTypes';
import acceptedImages from '../../../../../common/constants/acceptedImages';
import pictureTypeDescription from '../../../../../common/constants/pictureTypeDescription';
import BaseResponse from '../../../../../core/data/models/baseModels/baseResponse.model';
import moment from 'moment';
import { FormInputDirective } from '../../../../../common/directives/form-input.directive';
import VehiclePolicy from '../../../../../core/data/models/vehicle.policy.model';
import VehicleUses from '../../../../../common/enums/vehicleUsers';
import PoliceDepartment from '../../../../../common/enums/policeDepartment';
import {
  LocationService,
  StateDto,
  ZipFullDescDto,
} from '../../../services/location.service';

@Component({
  selector: 'app-form-step',
  imports: [
    NgSelectModule,
    FormsModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    ReactiveFormsModule,
    VehicleFormComponent,
    CristalFormComponent,
    ValidationModalComponent,
    SharedModule,
    FilePondModule,
    LocationPickerComponent,
  ],
  providers: [
    ClaimService,
    AuthService,
    SwalService,
    LocationService,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './form-step.component.html',
  styleUrl: './form-step.component.css',
})
export class FormStepComponent implements OnInit, OnDestroy {
  @ViewChild('validationModal') validationModal!: ValidationModalComponent;
  @ViewChild(VehicleFormComponent) vehicleFormComponent!: VehicleFormComponent;
  @ViewChild(CristalFormComponent) cristalFormComponent!: CristalFormComponent;
  @ViewChildren(LocationPickerComponent)
  locationPickers!: QueryList<LocationPickerComponent>;
  @ViewChildren(FormInputDirective)
  validatedInputs!: QueryList<FormInputDirective>;
  @Output() onFormCompleted = new EventEmitter<string>();
  @Output() onGoBack = new EventEmitter<void>();
  formInnerStep = 1;
  lossAddressCenter: google.maps.LatLngLiteral = {
    lat: repDomCoords.latitude,
    lng: repDomCoords.longitude,
  };
  vehicleLocationCenter: google.maps.LatLngLiteral = {
    lat: repDomCoords.latitude,
    lng: repDomCoords.longitude,
  };
  zoom = 15;
  loggedUser: User | null = null;
  states: StateDto[] = [];
  zipLocations: ZipFullDescDto[] = [];
  selectedStateCode: number | null = null;
  selectedZipCode: number | null = null;
  provinceInvalid = false;
  sectorInvalid = false;
  lossDateStruct: NgbDateStruct | null = null;
  lossTime = { hour: 0, minute: 0 };
  lossHourDisplay = '12';
  lossMinuteDisplay = '00';
  isPM = false;
  today: NgbDateStruct = (() => {
    const d = new Date();
    return { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
  })();
  claimForm = this.fb.group({
    lossDate: [moment().format('YYYY-MM-DDTHH:mm'), Validators.required],
    driverName: [''],
    isDriverOwner: [true],
    lossAddress: ['', Validators.required],
    lossDescription: ['', Validators.required],
    insuredIsGuilty: [false],
    insuredPhone: ['', Validators.required],
    vehicleLocation: this.fb.group({
      latitude: [null],
      longitude: [null],
      street: [null],
    }),
    policyNumber: ['', Validators.required],
    vehicleForm: this.fb.group({
      propertyDamage: this.fb.group({
        ownerName: [''],
        damageDescription: [''],
      }),
      vehicle: this.fb.group({
        isTowed: [false, Validators.required],
        unitNumber: [0, Validators.required],
        use: [0, Validators.required],
      }),
      driver: this.fb.group({
        isOwner: [true, Validators.required],
        documentId: [''],
        passport: [''],
        address: [''],
        email: [''],
        phone: [''],
        license: [''],
        licenceExpiry: [''],
        relation: [0],
      }),
      damageDescription: [[]],
      injured: this.fb.array([]),
      policeRegistryDepartment: [
        PoliceDepartment.DriverHouse,
        Validators.required,
      ],
      hasPoliceRegistry: [false],
      branch: [0, Validators.required],
      insuredIsGuilty: [false, Validators.required],
    }),
    cristalForm: this.fb.group({
      unitNumber: [0, Validators.required],
      isDriverOwner: [true, Validators.required],
      pictures: this.fb.array([]),
      isTowed: [false, Validators.required],
      hasInjured: [false, Validators.required],
    }),
    claimant: this.fb.group({
      email: [''],
      name: [''],
      phone: ['', Validators.required],
      isPolicyOwner: [true],
    }),
  });
  claimTypes = [
    { id: ClaimTypes.Vehicle, label: 'Colisión' },
    { id: ClaimTypes.Glass, label: 'Rotura de cristal' },
  ];
  claimTypeSelected: ClaimTypes = ClaimTypes.Vehicle;
  policyNumber: string = '';
  claimTypeEnum = ClaimTypes;
  injuredList: Injured[] = [];
  picOptions = {
    multiple: false,
    labelIdle: 'Arrastra la imagen o click para elegir',
    acceptedFileTypes: acceptedImages,
    allowReorder: true,
  };
  commonImages: (ImageType & { id: number })[] = [];
  cristalImages: ImageType[] = [];
  vehicleImages: ImageType[] = [];
  protected readonly ClaimTypes = ClaimTypes;
  protected readonly pictureTypes = pictureTypes;
  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private claimService: ClaimService,
    private authService: AuthService,
    private swalService: SwalService,
    private locationService: LocationService,
    private el: ElementRef,
  ) {}

  @Input({ required: true }) set vehicle({
    unitNumber,
    policy,
  }: {
    policy: VehiclePolicy;
    unitNumber: number;
  }) {
    this.claimForm.patchValue({
      vehicleForm: {
        vehicle: {
          unitNumber,
          use: VehicleUses[policy.vehicleInfo.use],
        },
      },
    });
  }

  @Input() set value(policy: Policy | null) {
    if (policy) {
      this.policyNumber = policy.policyNumber;
      this.claimForm.patchValue({
        policyNumber: this.policyNumber,
      });
    }
  }

  get vehicleForm() {
    return this.claimForm.get('vehicleForm') as FormGroup;
  }

  get cristalForm() {
    return this.claimForm.get('cristalForm') as FormGroup;
  }

  get formImages() {
    return this.commonImages
      .map((c) => ({ file: c.file, type: c.type }))
      .concat(this.vehicleImages)
      .concat(this.cristalImages);
  }

  handleAddImage($event: any, type: PictureTypes) {
    this.commonImages.push({
      id: $event.file.id,
      file: $event.file.file,
      type,
    });
  }

  handleRemoveImage($event: any) {
    const index = this.commonImages.findIndex(
      (image) => image.id === $event.file.id,
    );

    if (index > -1) {
      this.commonImages.splice(index, 1);
    }
  }

  onDateTimeChange() {
    if (!this.lossDateStruct) return;
    const { year: y, month: m, day: d } = this.lossDateStruct;
    const h = this.lossTime.hour.toString().padStart(2, '0');
    const min = this.lossTime.minute.toString().padStart(2, '0');
    const iso = `${y}-${m.toString().padStart(2, '0')}-${d.toString().padStart(2, '0')}T${h}:${min}`;
    this.claimForm.controls.lossDate.setValue(iso);
  }

  adjustHour(delta: number) {
    let h12 = parseInt(this.lossHourDisplay, 10) || 12;
    h12 = ((h12 - 1 + delta + 12) % 12) + 1;
    this.lossHourDisplay = h12.toString().padStart(2, '0');
    this.syncTimeFrom12h();
  }

  adjustMinute(delta: number) {
    let m = parseInt(this.lossMinuteDisplay, 10) || 0;
    m = ((m + delta) + 60) % 60;
    this.lossMinuteDisplay = m.toString().padStart(2, '0');
    this.syncTimeFrom12h();
  }

  toggleMeridian() {
    this.isPM = !this.isPM;
    this.syncTimeFrom12h();
  }

  onTimeInputBlur() {
    let h = parseInt(this.lossHourDisplay, 10) || 12;
    h = Math.min(12, Math.max(1, h));
    this.lossHourDisplay = h.toString().padStart(2, '0');
    let m = parseInt(this.lossMinuteDisplay, 10) || 0;
    m = Math.round(m / 5) * 5;
    m = Math.min(55, Math.max(0, m));
    this.lossMinuteDisplay = m.toString().padStart(2, '0');
    this.syncTimeFrom12h();
  }

  private syncTimeFrom12h() {
    let h = parseInt(this.lossHourDisplay, 10) || 12;
    if (this.isPM) {
      h = h === 12 ? 12 : h + 12;
    } else {
      h = h === 12 ? 0 : h;
    }
    this.lossTime = { hour: h, minute: parseInt(this.lossMinuteDisplay, 10) || 0 };
    this.onDateTimeChange();
  }

  private syncDisplayFrom24h(h24: number, min: number) {
    this.isPM = h24 >= 12;
    const h12 = h24 % 12 || 12;
    this.lossHourDisplay = h12.toString().padStart(2, '0');
    this.lossMinuteDisplay = min.toString().padStart(2, '0');
  }

  ngOnInit(): void {
    // Initialize date/time pickers from the default lossDate value
    const defaultDate = this.claimForm.controls.lossDate.value;
    if (defaultDate) {
      const [datePart, timePart] = defaultDate.split('T');
      const [y, mo, d] = datePart.split('-').map(Number);
      this.lossDateStruct = { year: y, month: mo, day: d };
      if (timePart) {
        const [h, min] = timePart.split(':').map(Number);
        this.lossTime = { hour: h, minute: min };
        this.syncDisplayFrom24h(h, min);
      }
    }

    const authSub = this.authService.userSubject.subscribe((user) => {
      if (!user) return;

      this.loggedUser = user;
      this.claimForm.controls.driverName.setValue(
        user.idTokenClaims!.given_name,
      );
      this.claimForm.controls.insuredPhone.setValue(user.phone);
      this.claimForm.controls.claimant.controls.name.setValue(
        user.idTokenClaims!.given_name!,
      );

      if (this.claimForm.value.claimant?.isPolicyOwner) {
        this.claimForm.controls.claimant.controls.phone.setValue(user.phone);
      }
    });
    this.subscriptions.push(authSub);

    // Load states for province/sector dropdowns
    this.locationService.getStates().subscribe((states) => {
      this.states = states;
    });

    // Dynamically require vehicle street when either latitude or longitude is set
    const vehicleLocationGroup = this.claimForm.controls.vehicleLocation;
    const latitudeCtrl = vehicleLocationGroup.controls.latitude;
    const longitudeCtrl = vehicleLocationGroup.controls.longitude;
    const streetCtrl = vehicleLocationGroup.controls.street;

    const updateStreetRequired = () => {
      const hasCoords = !!latitudeCtrl.value || !!longitudeCtrl.value;
      if (hasCoords) {
        streetCtrl.addValidators(Validators.required);
      } else {
        streetCtrl.removeValidators(Validators.required);
      }
      // Update validity without causing cascading emissions
      streetCtrl.updateValueAndValidity({ emitEvent: false });
    };

    const latSub = latitudeCtrl.valueChanges.subscribe(updateStreetRequired);
    const lngSub = longitudeCtrl.valueChanges.subscribe(updateStreetRequired);
    this.subscriptions.push(latSub, lngSub);
    // Initialize once on start in case values are pre-filled
    updateStreetRequired();
  }

  onStateChange(stateCode: number | null) {
    this.selectedStateCode = stateCode;
    this.selectedZipCode = null;
    this.zipLocations = [];
    if (stateCode) this.provinceInvalid = false;

    if (stateCode) {
      this.locationService
        .getZipLocationsByState(stateCode)
        .subscribe((zips) => {
          this.zipLocations = zips;
        });
    }
  }

  onZipChange(zipCode: number | null) {
    this.selectedZipCode = zipCode;
    if (zipCode) this.sectorInvalid = false;
  }

  handleVehicleDragEnd($event: any) {
    const latitude = $event.latLng.lat();
    const longitude = $event.latLng.lng();

    this.claimForm.controls.vehicleLocation.patchValue({
      latitude,
      longitude,
      street: $event.street || '',
    });
  }

  onInjuredAdded(injured: Injured[]) {
    this.injuredList = injured;
  }

  onCodeValidated = async (response: ValidationModalResponse) => {
    if (response.validated) {
      this.swalService.showLoading('Generando reclamo');

      let claimId = '';

      try {
        if (this.claimTypeSelected === ClaimTypes.Vehicle) {
          claimId = await this.createVehicleClaim(
            response.claimReferenceNumber,
          );
        } else if (this.claimTypeSelected === ClaimTypes.Glass) {
          claimId = await this.createCristalClaim(
            response.claimReferenceNumber,
          );
        }
      } catch (e) {
        const errorMessage =
          typeof e === 'string'
            ? e
            : (e as any)?.error?.message ||
              (e as any)?.message ||
              'Error desconocido';
        this.swalService.notification(
          `Ha ocurrido un error creando el reclamo: ${errorMessage}`,
        );
        return;
      }

      try {
        await this.uploadImages(claimId);
      } catch (e) { }

      this.swalService.dismiss();
      this.claimForm.reset();

      this.onFormCompleted.emit(claimId);
    }
  };

  createCristalClaim = async (claimReferenceNumber: string) => {
    const values = this.claimForm.value;
    const claimData: ClaimGlassRequest = {
      insuredPhone: values.insuredPhone!,
      lossDate: values.lossDate!,
      lossAddress: {
        street: values.lossAddress || '',
        stateCode: this.selectedStateCode ?? undefined,
        zipCode: this.selectedZipCode ?? undefined,
      },
      lossDescription: values.lossDescription || '',
      policyNumber: values.policyNumber!,
      unitNumber: values.vehicleForm?.vehicle?.unitNumber!,
      claimant: {
        name: values.claimant?.name!,
        phone: values.claimant?.phone!,
        isPolicyOwner: values.claimant?.isPolicyOwner!,
      },
      driverName: values.driverName!,
      vehicleLocation:
        values.vehicleLocation?.latitude == null
          ? null
          : {
              latitude: values.vehicleLocation.latitude!,
              longitude: values.vehicleLocation.longitude!,
              street: values.vehicleLocation.street!,
            },
    };

    const result = await lastValueFrom(
      this.claimService.createGlassClaim(claimData, claimReferenceNumber),
    );

    return result.data.eventNumber;
  };

  uploadImages = async (claimReferenceNumber: string) => {
    return Promise.all(
      this.formImages.map(async (i) =>
        lastValueFrom(
          this.claimService.upload<BaseResponse<number>>(
            i.file,
            `Claims/${claimReferenceNumber}/File?description=${pictureTypeDescription[i.type]}`,
          ),
        ),
      ),
    );
  };

  createVehicleClaim = async (claimReferenceNumber: string) => {
    const values = this.claimForm.value;
    const claimData: VehicleClaimRequest = {
      insuredPhone: values.insuredPhone!,
      eventDescription: values.lossDescription || '',
      lossDate: values.lossDate!,
      lossAddress: {
        street: values.lossAddress || '',
        stateCode: this.selectedStateCode ?? undefined,
        zipCode: this.selectedZipCode ?? undefined,
      },
      policyNumber: values.policyNumber!,
      propertyDamage: values.vehicleForm!.propertyDamage?.ownerName
        ? {
          ownerName: values.vehicleForm!.propertyDamage?.ownerName,
          damageDescription:
            values.vehicleForm!.propertyDamage?.damageDescription!,
        }
        : null,
      vehicle: {
        unitNumber: values.vehicleForm!.vehicle!.unitNumber!,
        use: values.vehicleForm!.vehicle!.use!,
        isTowed: values.vehicleForm!.vehicle!.isTowed!,
      },
      driver: {
        isOwner: values.vehicleForm!.driver!.isOwner!,
        name: values.driverName!,
        documentId: values.vehicleForm!.driver!.documentId || undefined,
        passport: values.vehicleForm!.driver!.passport || undefined,
        address: values.vehicleForm!.driver!.address || undefined,
        license: values.vehicleForm!.driver!.license || undefined,
        licenceExpiry: values.vehicleForm!.driver!.licenceExpiry || undefined,
        relation: values.isDriverOwner
          ? undefined
          : values.vehicleForm!.driver!.relation!,
        phone: values.vehicleForm!.driver!.phone || undefined,
        email: values.vehicleForm!.driver!.email || undefined,
      },
      claimant: {
        name: values.claimant?.name!,
        phone: values.claimant?.phone!,
        isPolicyOwner: values.claimant?.isPolicyOwner!,
      },
      vehicleLocation:
        values.vehicleLocation!.latitude == null
          ? null
          : {
              latitude: values.vehicleLocation!.latitude!,
              longitude: values.vehicleLocation!.longitude!,
              street: values.vehicleLocation!.street!,
            },
      damageDescription: values.vehicleForm?.damageDescription!,
      injured: this.injuredList,
      policeRegistryDepartment: values.vehicleForm?.hasPoliceRegistry
        ? parseInt(
            values.vehicleForm?.policeRegistryDepartment as unknown as string,
          )
        : null,
      insuredIsGuilty: values.insuredIsGuilty!,
    };

    const result = await lastValueFrom(
      this.claimService.createVehicleClaim(claimData, claimReferenceNumber),
    );

    return result.data;
  };

  onSubmit = async () => {
    [
      ...this.validatedInputs.toArray(),
      ...(this.vehicleFormComponent?.validatedInputs.toArray() || []),
      ...(this.cristalFormComponent?.validatedInputs.toArray() || []),
    ].forEach((i) => {
      i.validateControl();
    });

    const lossInvalid = this.claimForm.controls.lossAddress.invalid;
    const vehicleStreetInvalid =
      this.claimForm.controls.vehicleLocation.controls.street.invalid;

    const allPickers = [
      ...(this.locationPickers?.toArray() || []),
      ...(this.vehicleFormComponent?.locationPickers?.toArray() || []),
    ];
    allPickers.forEach((p) => {
      if (p.mapId === 'lossAddress') {
        p.markAsTouchedIfInvalid(lossInvalid);
      } else {
        p.markAsTouchedIfInvalid(vehicleStreetInvalid);
      }
    });

    if (this.claimForm.invalid) {
      // Scroll to first invalid element
      const firstInvalidElement = document.querySelector('.is-invalid');
      if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }

      return;
    }

    if (!this.arePicturesValid()) {
      return;
    }

    this.validationModal.show({
      claimType: this.claimTypeSelected,
      policyNumber: this.claimForm.value.policyNumber!,
      claimantEmail: this.claimForm.value.claimant?.email!,
    }, true);
  };

  arePicturesValid() {
    const required: PictureTypes[] = [
      PictureTypes.LicensePicture,
      PictureTypes.VehicleRegistryPicture,
    ];

    if (this.claimTypeSelected === ClaimTypes.Vehicle) {
      required.push(
        PictureTypes.VehicleLeftSidePicture,
        PictureTypes.VehicleRightSidePicture,
        PictureTypes.VehicleFrontPicture,
        PictureTypes.VehicleBackPicture,
        PictureTypes.DriverIdPicture,
      );

      if (this.claimForm.value.vehicleForm?.hasPoliceRegistry) {
        required.push(PictureTypes.PoliceRegistryPicture);
      }

      if (this.claimForm.value.vehicleForm?.vehicle?.isTowed) {
        required.push(PictureTypes.VehicleMileagePicture);
      }
    } else if (this.claimTypeSelected === ClaimTypes.Glass) {
      required.push(
        PictureTypes.VehicleGlassPicture,
        PictureTypes.VehicleVinPicture,
        PictureTypes.VehiclePlatePicture,
      );
    }

    const missing = required
      .filter((t) => !this.formImages.find((i) => i.type === t))
      .map((t) => pictureTypeDescription[t]);

    if (missing.length) {
      this.swalService.fieldsRequired(missing);
      return false;
    }

    return true;
  }

  handlePolicyOwnerChange() {
    const nameCtrl = this.claimForm.controls.claimant.controls.name;

    if (this.claimForm.value.claimant!.isPolicyOwner) {
      this.claimForm.controls.claimant.controls.email.clearValidators();
      this.claimForm.controls.claimant.controls.phone.clearValidators();
      this.claimForm.controls.insuredPhone.addValidators([Validators.required]);
      nameCtrl.setValue(this.loggedUser?.idTokenClaims?.given_name ?? '');
      nameCtrl.clearValidators();
    } else {
      this.claimForm.controls.claimant.controls.email.addValidators([
        Validators.required,
        Validators.email,
      ]);
      this.claimForm.controls.claimant.controls.phone.addValidators([Validators.required]);
      this.claimForm.controls.insuredPhone.clearValidators();
      nameCtrl.setValue('');
      nameCtrl.addValidators([Validators.required]);
    }

    nameCtrl.updateValueAndValidity();
    this.claimForm.controls.claimant.controls.email.updateValueAndValidity();
    this.claimForm.controls.claimant.controls.phone.updateValueAndValidity();
    this.claimForm.controls.insuredPhone.updateValueAndValidity();
    this.claimForm.updateValueAndValidity();
  }

  handleDriverOwnerChange() {
    const driverControls =
      this.claimForm.controls.vehicleForm.controls.driver.controls;

    if (this.claimForm.value.isDriverOwner) {
      this.claimForm.controls.driverName.patchValue(
        this.loggedUser?.idTokenClaims?.given_name || '',
      );
      driverControls.email.clearValidators();
      driverControls.phone.clearValidators();
    } else {
      this.claimForm.controls.driverName.patchValue('');
      driverControls.email.addValidators([
        Validators.required,
        Validators.email,
      ]);
      driverControls.phone.addValidators([Validators.required]);
    }

    driverControls.email.updateValueAndValidity();
    driverControls.phone.updateValueAndValidity();
  }

  onVehicleImagesSelected($event: { file: File; type: PictureTypes }[]) {
    this.vehicleImages = $event;
  }

  onCrisalImagesSelected($event: { file: File; type: PictureTypes }[]) {
    this.cristalImages = $event;
  }

  // Handlers for shared LocationPickerComponent
  onLossAddressSelected($event: {
    fullAddress?: string;
    street?: string;
    location: google.maps.LatLngLiteral;
  }) {
    this.claimForm.controls.lossAddress.setValue($event.street || '');
    if ($event.location) {
      this.lossAddressCenter = $event.location;
      this.zoom = 17;
    }
    this.scrollToFirstInvalidPickerIfAny();
  }

  onLossAddressDragged($event: {
    fullAddress?: string;
    street?: string;
    location: google.maps.LatLngLiteral;
  }) {
    this.claimForm.controls.lossAddress.setValue($event.street || '');
    if ($event.location) {
      this.lossAddressCenter = $event.location;
    }
    this.scrollToFirstInvalidPickerIfAny();
  }

  onVehicleLocationSelected($event: {
    fullAddress?: string;
    street?: string;
    location: google.maps.LatLngLiteral;
  }) {
    if ($event.location) {
      this.vehicleLocationCenter = $event.location;
      this.claimForm.controls.vehicleLocation.patchValue({
        latitude: this.vehicleLocationCenter.lat as any,
        longitude: this.vehicleLocationCenter.lng as any,
        street: ($event.street || '') as any,
      });
      this.zoom = 17;
    }
    this.scrollToFirstInvalidPickerIfAny();
  }

  onVehicleLocationDragged($event: {
    fullAddress?: string;
    street?: string;
    location: google.maps.LatLngLiteral;
  }) {
    if ($event.location) {
      this.vehicleLocationCenter = $event.location;
      this.claimForm.controls.vehicleLocation.patchValue({
        latitude: this.vehicleLocationCenter.lat as any,
        longitude: this.vehicleLocationCenter.lng as any,
        street: ($event.street || '') as any,
      });
    }
    this.scrollToFirstInvalidPickerIfAny();
  }

  private scrollToFirstInvalidPickerIfAny() {
    setTimeout(() => {
      this.locationPickers
        ?.toArray()
        .some((picker) => picker.scrollIntoViewIfInvalid());
    }, 0);
  }

  get isStep1Valid(): boolean {
    const c = this.claimForm.controls;
    const isPolicyOwner = this.claimForm.value.claimant?.isPolicyOwner;

    const baseValid = c.lossDate.valid && c.lossAddress.valid && c.lossDescription.valid
      && !!this.selectedStateCode && !!this.selectedZipCode;
    if (!baseValid) return false;

    if (isPolicyOwner) {
      return c.insuredPhone.valid;
    }
    return (
      c.claimant.controls.name.valid &&
      c.claimant.controls.email.valid &&
      c.claimant.controls.phone.valid
    );
  }

  nextInnerStep() {
    const missing = this.getStep1MissingFields();
    if (missing.length) {
      this.markStep1Controls();
      this.swalService.fieldsRequired(missing).then(() => this.focusFirstInvalidStep1Field());
      return;
    }
    this.formInnerStep = 2;
  }

  private markStep1Controls() {
    const c = this.claimForm.controls;
    const isPolicyOwner = this.claimForm.value.claimant?.isPolicyOwner;

    const touch = (ctrl: { markAsDirty(): void; updateValueAndValidity(): void }) => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    };

    touch(c.lossDate);
    touch(c.lossAddress);
    touch(c.lossDescription);

    this.provinceInvalid = !this.selectedStateCode;
    this.sectorInvalid = !this.selectedZipCode;

    this.locationPickers?.find(p => p.mapId === 'lossAddress')
      ?.markAsTouchedIfInvalid(c.lossAddress.invalid);

    if (isPolicyOwner) {
      touch(c.insuredPhone);
    } else {
      touch(c.claimant.controls.name);
      touch(c.claimant.controls.email);
      touch(c.claimant.controls.phone);
    }
  }

  private focusFirstInvalidStep1Field() {
    const c = this.claimForm.controls;
    const isPolicyOwner = this.claimForm.value.claimant?.isPolicyOwner;
    const host = this.el.nativeElement as HTMLElement;

    const focus = (key: string) => {
      const el = host.querySelector(`[data-focus-key="${key}"]`) as HTMLElement;
      el?.focus();
      el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    setTimeout(() => {
      if (c.lossDate.invalid) { focus('lossDate'); return; }
      if (c.lossAddress.invalid) {
        this.locationPickers.find(p => p.mapId === 'lossAddress')?.focusInput();
        return;
      }
      if (c.lossDescription.invalid) { focus('lossDescription'); return; }
      if (isPolicyOwner) {
        if (c.insuredPhone.invalid) focus('insuredPhone');
      } else {
        if (c.claimant.controls.name.invalid) { focus('claimantName'); return; }
        if (c.claimant.controls.email.invalid) { focus('claimantEmail'); return; }
        if (c.claimant.controls.phone.invalid) { focus('claimantPhone'); }
      }
    }, 300);
  }

  private getStep1MissingFields(): string[] {
    const c = this.claimForm.controls;
    const missing: string[] = [];

    if (c.lossDate.invalid) missing.push('Fecha del siniestro');
    if (c.lossAddress.invalid) missing.push('¿Dónde ocurrió el siniestro?');
    if (c.lossDescription.invalid) missing.push('Descripción del siniestro');
    if (!this.selectedStateCode) missing.push('Provincia');
    if (!this.selectedZipCode) missing.push('Sector/Paraje');

    const isPolicyOwner = this.claimForm.value.claimant?.isPolicyOwner;
    if (isPolicyOwner) {
      if (c.insuredPhone.invalid) missing.push('Teléfono del titular de la póliza');
    } else {
      if (c.claimant.controls.name.invalid) missing.push('Nombre del Reclamante');
      if (c.claimant.controls.email.invalid) missing.push('Correo de quien realiza el reclamo');
      if (c.claimant.controls.phone.invalid) missing.push('Teléfono de quien realiza el reclamo');
    }

    return missing;
  }

  prevInnerStep() {
    if (this.formInnerStep === 1) {
      this.onGoBack.emit();
    } else {
      this.formInnerStep = 1;
    }
  }

  onLossAddressChanged(address?: string) {
    this.claimForm.controls.lossAddress.setValue(address || '');
  }

  onVehicleLocationAddressChanged(address?: string) {
    this.claimForm.controls.vehicleLocation.patchValue({
      street: (address || '') as any,
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
